import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=5b787693&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=5b787693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b787693",
  null
  
)

export default component.exports